<script setup>
import { setLocale } from '@/i18n';
import { useI18n } from 'vue-i18n';

const { locale, t } = useI18n();

function toggleLocale() {
  setLocale(locale.value === 'ar' ? 'en' : 'ar');
}
</script>

<template>
  <header class="topbar">
    <button
      class="lang-btn"
      type="button"
      @click="toggleLocale"
      :aria-label="locale === 'ar' ? 'Switch to English' : 'تبديل إلى العربية'"
    >
      {{ locale === 'ar' ? 'EN' : 'العربية' }}
    </button>
    <div class="address-pill">
      <span aria-hidden="true">📍</span>
      <span>{{ locale === 'ar' ? 'الرياض، حي العليا' : 'Riyadh, Olaya' }}</span>
    </div>
    <RouterLink to="/" class="brand">
      <img src="/assets/brand/meed-logo.png" :alt="t('app.name')" />
    </RouterLink>
  </header>
</template>

<style scoped>
.topbar {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: var(--s-3);
  align-items: center;
  padding: var(--s-3) var(--s-4);
  background: linear-gradient(180deg, var(--brand-blue-soft), #eef8ff);
  border-bottom: 1px solid rgba(12, 77, 119, 0.12);
  position: sticky;
  top: 0;
  z-index: 30;
}
.lang-btn {
  background: var(--surface);
  color: var(--brand-blue);
  border: 1px solid #cfe0ef;
  border-radius: var(--radius-sm);
  padding: 8px 12px;
  font-weight: 700;
  font-size: 13px;
  transition: background var(--t);
}
.lang-btn:hover { background: var(--bg-soft); }
.address-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--surface);
  border: 1px solid var(--line);
  padding: 8px 14px;
  border-radius: var(--radius-pill);
  font-weight: 600;
  font-size: 13px;
  color: var(--brand-blue-strong);
  justify-self: center;
}
.brand img {
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: var(--radius);
}
</style>
